ArchivableMixin = require 'app/scripts/lib/archivable-mixin'
LimitMixin = require 'app/scripts/lib/limit-mixin'
TrelloModel = require 'app/scripts/models/internal/trello-model'
Util = require 'app/scripts/lib/util'
containsUrl = require 'app/scripts/lib/util/url/contains-url'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
{ truncate } = require 'app/common/lib/util/text/truncate'
fileUploadOptions = require 'app/scripts/network/jquery-file-upload-options'
xtend = require 'xtend'
_ = require 'underscore'

class List extends TrelloModel
  mixin ArchivableMixin, LimitMixin, @

  typeName: 'List'
  urlRoot: '/1/lists'

  @lazy
    cardList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      CardList = require 'app/scripts/models/collections/card-list'
      new CardList(null, { list: @ })
      .owner(@)
      .syncCache @modelCache, ['idList', 'closed'], (card) =>
        @id && card.get('idList') == @id && card.isOpen()

  sync: (method, model, options) ->
    if method == 'create' && !(@get('idBoard')?)
      @waitForAttrs @, ['idBoard'], (attrs) =>
        @set(attrs)
        super(method, model, options)

      @waitForId @getBoard(), (id) => @set('idBoard', id)
    else
      super

  subscribe: (subscribed, next) ->
    return if subscribed == @get('subscribed')
    @update { subscribed }, next

    return

  move: (index) ->
    @update(pos: @getBoard().calcPos(index, @))
    @collection.sort({ silent: true })
    return

  close: ->
    @update({ closed: true })
    return

  reopen: ->
    @update({
      closed: false
      pos: @getBoard().calcPos(@collection.length, @)
    })
    return

  onChange: ->
    return

  calcPos: (index, card, includeCard) ->
    Util.calcPos(index, @cardList, card, null, includeCard)

  bottomCardPos: ->
    # The cards are sorted by pos, so the next pos is the one right after
    if (lastCard = @cardList.last())?
      lastCard.get('pos') + Util.spacing
    else
      Util.spacing

  getBoard: ->
    @modelCache.get('Board', @get('idBoard')) ? @collection?.owner

  selectCardInList: (index) ->
    selectCard = @openCards().at(index)

    if selectCard?
      @getBoard().viewState.selectCard(selectCard)

    return

  selectFirstCardInList: ->
    @selectCardInList(0)

  editable: -> @getBoard().editable()

  isTemplate: -> @getBoard().isTemplate()

  getIndexInList: ->
    _.indexOf(@getBoard().listList.models, @)

  hasCapacity: (item) ->
    list = item.getList?()
    if list?
      return !list.isOverLimit('cards', 'openPerList') &&
      !list.isOverLimit('cards', 'totalPerList') &&
      item.getBoard?().hasCapacity(item)
    return false

  openCards: -> @cardList

  uploadUrl: (url, cardData, placeholderText, next = ->) ->
    # Because we have no idea what to call the card that we're creating, but
    # there's a good chance that the server will be able to get a name based
    # on what's at the URL, we're going to have the local card model called
    # something like "Loading from imdb.com…" and then get a better name back
    # from the server
    #
    # We have to specify the local attributes separately from what we send to
    # the server, so we can have a temporary name for the card without sending
    # it to the server
    @cardList.create xtend({
      name: placeholderText
      pos: @bottomCardPos()
    }, cardData), {
      createData:
        urlSource: url
        # explicitly include the name here, even if it's undefined, so we
        # override whatever is being used as a placeholder
        name: cardData?.name
    }, next

  # Given some arbitrary text, convert it to a name (and possible description)
  _processText: (text) ->
    # Get an appropriate name/description for an arbitrary blob of text
    if /[\r\n]/.test(text)
      # If the text contains a newline, then use the first line as the name
      [all, firstLine] = ///
        ^
        \s*
        ([^\r\n]+)
      ///.exec(text)

      name = truncate(firstLine, 256)
      desc = text
    else
      name = truncate(text, 256)
      # If the name got clipped or contains a URL (which wouldn't be clickable)
      # then also put the text into the description
      if name != text || containsUrl(text)
        desc = text
      else
        desc = ""

    { name, desc }

  uploadText: (text, next = ->) ->
    if !text
      return next()

    { name, desc } = @_processText(text)

    @cardList.create {
      name
      desc
      pos: @bottomCardPos()
    }, next

  upload: (file, name, next = ->) ->
    localData =
      name: name
      idList: @id
      pos: @bottomCardPos()

    options = fileUploadOptions _.extend {}, localData,
      fileSource: [file, name]

    @cardList.create localData, options

  setSoftLimit: (softLimit) ->
    @update({ softLimit })
    return

module.exports = List
